import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { forwardRef, memo } from "react";
export const SearchCommandActions = /*#__PURE__*/ memo(/*#__PURE__*/ forwardRef((param, ref)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: tailwindMerge("absolute bottom-0 right-2 top-0 flex items-center gap-2", className),
        ref: ref,
        ...restOfProps
    });
}));
SearchCommandActions.displayName = "SearchCommandActions";
